import { useEffectOnce } from 'react-use';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction, Layouts } from '~/shared';
import { Head } from '../../components/Head';
import {
	resetStore,
	setStage,
	StageTypes,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { VehicleRegistrationMain } from '../VehicleRegistrationMain';
import { VehicleRegistrationRegionSelection } from '../VehicleRegistrationRegionSelection';
import { StyledContainer, StyledContent } from './VehicleRegistration.styled';

const VehicleRegistration = () => {
	const dispatch = useLayoutDispatch();
	const modalState = useObservable(rage.modal.getCurrentModal());
	const stage = useLayoutSelector(
		(state) => state.vehicleRegistrationSlice.stage,
	);

	useInputAction(InputAction.CommonMenuClose, () => {
		if (modalState) {
			return;
		}

		if (stage === StageTypes.RegionSelection) {
			dispatch(setStage(StageTypes.Main));
			return;
		}

		rage.vehicleRegistration
			.exitMenu()
			.catch((err) => rage.notifications.showException(err));
	});

	useEffectOnce(() => {
		return () => {
			dispatch(resetStore());
		};
	});

	return (
		<StyledContainer className={Layouts.VehicleRegistration}>
			<Head />
			<StyledContent>
				<VehicleRegistrationMain />
				{stage === StageTypes.RegionSelection && (
					<VehicleRegistrationRegionSelection />
				)}
			</StyledContent>
		</StyledContainer>
	);
};

export { VehicleRegistration };
